import React, { useState, useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter"; // , {textFilter, selectFilter, dateFilter,}
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"; // , { Search, CSVExport,}
const { ExportCSVButton } = CSVExport;

// import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
// import { toast } from "react-toastify";
import { Row, Col, Form, Button, FormControl } from "react-bootstrap";
// import { CSVLink } from "react-csv";

// Import Service
import factoryService from "../../services/factory.service";
// import authService from "../../services/auth.service";
import ContractService from "../../services/contract.service";
// import farmerService from "../../services/farmer.service";

//Import Loading
// import Spinner from "react-bootstrap/Spinner";
// import { confirmAlert } from "react-confirm-alert";
import LoadingAlert from "../../components/LoadingAlert";

// Import Modal
import ModalListContractYear from "./ModalListContractYear";
// import ModalViewDetail from "./modalViewMembers";
// import ModalAddFactory from "./modalAddFactory";
// import ModalEditFactory from "./modalEditFactory";
// import ModalCheckMember from "./modalCheckMember";
// import MemberForm from "./formMember";

//Import tooltip
// import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";

import "./factory.css";

const ContractListForOcsb = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [factoryFilter, setFactoryFilter] = useState([]);
  const [search, setSearch] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [years, setYears] = useState([]);
  const [optionPeriod, setOptonPeriod] = useState([]);

  // const user = authService.getCurrentUser();

  const clickDelete = (years) => {
    setLoading(true);
    ContractService.deleteYears({ years: years })
      .then((response) => {
        alert(response.data.years);
        setYears((a) => a.filter((b) => b.season != response.data.years));
      })
      .catch((err) => console.log(err.response.data.message))
      .finally(() => setLoading(false));
  };

  const onClickManage = (e) => {
    e.preventDefault();
    setLoading(true);
    ContractService.getYears()
      .then((response) => {
        setYears(response.data.data);
        setShowModal(true);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  const importYears = async (year, offset) => {
    let res = 1000;
    let i = parseInt(offset);
    setLoading(true);
    while (res != 0) {
      await ContractService.importYears({
        years: year,
        user_id: 1,
        offset: i,
      }).then((response) => {
        res = response.data.data.total;
        i = i + 1000;
        setYears((y) => {
          if (y.find((a) => a.season == response.data.data.season)) {
            return y.map((a) => {
              if (a.season == response.data.data.season) {
                return {
                  season: a.season,
                  total: parseInt(response.data.data.total) + parseInt(a.total),
                };
              } else {
                return a;
              }
            });
          } else {
            return [
              ...years,
              {
                season: response.data.data.season,
                total: parseInt(response.data.data.total),
              },
            ];
          }
        });
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    // getData();
    // getFactory();
    getPeriod();
    getFactoryFilter();
    setLoading(false);
  }, []);

  const getData = () => {
    setLoading(true);
    ContractService.getContracts(search)
      .then((response) => {
        console.log(response);
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getFactoryFilter = () => {
    factoryService.getFactorylist().then((response) => {
      setFactoryFilter(response.data.data);
      // console.log(props);
    });
  };

  // const optionPeriod = [
  //   { value: "2563-2564", label: "2563-2564" },
  //   { value: "2564-2565", label: "2564-2565" },
  //   { value: "2565-2566", label: "2565-2566" },
  // ];

  const getPeriod = () => {
    ContractService.getYears().then((response) =>
      setOptonPeriod(response.data.data)
    );
  };

  const handleSearch = (e) => {
    e.preventDefault();
    getData();
  };

  const setField = (field, value) => {
    setSearch((a) => ({
      ...a,
      [field.name]: value,
    }));
  };

  // const showCSVButton = () => {
  //   if (user.user.member_type === 5 || user.user.member_type === 8) {
  //     return (
  //       <CSVLink
  //         data={data}
  //         headers={[...headers.filter((a) => a.csvExport !== false)]}
  //         filename={"คู่สัญญา.csv"}
  //         className="btn btn-success"
  //         target="_blank"
  //         style={{
  //           padding: ".375rem .75rem",
  //           fontSize: "1rem",
  //           float: "right",
  //         }}
  //       >
  //         <i className="bi bi-download"></i>
  //       </CSVLink>
  //     );
  //   } else if (user.user.member_type === 6) {
  //     return (
  //       <div>
  //         <CSVLink
  //           data={data}
  //           headers={[...headers.filter((a) => a.csvExport !== false)]}
  //           filename={"คู่สัญญา.csv"}
  //           className="btn btn-success"
  //           target="_blank"
  //           style={{
  //             padding: ".375rem .75rem",
  //             fontSize: "1rem",
  //             float: "right",
  //           }}
  //         >
  //           <i className="bi bi-download"></i>
  //         </CSVLink>
  //       </div>
  //     );
  //   }
  // };

  const dateFormatter = (cell) => {
    const getdate = new Date(cell);
    return (
      <p>
        {getdate.toLocaleString("th-TH", {
          year: "2-digit",
          month: "short",
          day: "numeric",
        })}
      </p>
    );
  };

  const headerSortingStyle = {
    backgroundColor: "#D4EFDF",
    verticalAlign: "center",
  };

  const columns = [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      csvExport: false,
    },
    {
      text: "ปีที่ส่ง",
      dataField: "season",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
      filter: textFilter({
        placeholder: "ปีทีส่ง",
        style: { fontSize: "98%", width: "100%" },
      }),
    },
    {
      text: "เลขสัญญา",
      dataField: "contract_no",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "15%" };
      },
      headerSortingStyle,
      filter: textFilter({
        placeholder: "เลขสัญญา",
        style: { fontSize: "98%", width: "100%" },
      }),
    },
    {
      text: "รหัสโรงงาน",
      dataField: "factory_code",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "left",
      },
      filter: textFilter({
        placeholder: "รหัสโรงงาน",
        style: { fontSize: "98%", width: "100%" },
      }),
    },
    {
      text: "เลขบัตรประชาชน",
      dataField: "thai_no",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "25%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "right",
      },
      filter: textFilter({
        placeholder: "เลขบัตรประชาชน",
        style: { fontSize: "98%", width: "100%" },
      }),
    },
    {
      text: "ยอดจด (ตัน)",
      dataField: "contract_cane",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "right",
      },
    },
    {
      text: "ส่งจริง (ตัน)",
      dataField: "delivered_cane",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "right",
      },
    },
    {
      text: "เริ่มสัญญา",
      formatter: dateFormatter,
      dataField: "contract_date",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
    },
    // {
    //   text: "แก้ไข",
    //   dataField: "edit",
    //   isDummyField: true,
    //   editable: false,
    //   formatter: actionsViewFormatter,
    //   headerStyle: () => {
    //     return { verticalAlign: "middle", width: "10%" };
    //   },
    //   headerSortingStyle,
    // },
  ];

  // const headers = [
  //   ...columns.map((a) => {
  //     return { label: a.text, key: a.dataField, csvExport: a.csvExport };
  //   }),
  // ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  // if (loading)
  //   return (
  //     <>
  //       <p>
  //         <Spinner animation="border" variant="success" />
  //         <span>&nbsp;กรุณารอ เนื่องจากข้อมูลมีปริมาณมาก</span>
  //       </p>
  //     </>
  //   );
  if (error) return `Error :${error}`;

  return (
    <div>
      <ModalListContractYear
        show={showModal}
        setShow={setShowModal}
        years={years}
        import={importYears}
        delete={clickDelete}
      />
      {loading ? <LoadingAlert /> : ""}
      <ToolkitProvider
        bootstrap4
        keyField="id"
        data={data}
        columns={columns}
        exportCSV={{
          fileName: "custom.csv",
          noAutoBOM: false,
          blobType: "text/plain;charset=utf-8",
        }}
        search
      >
        {(prop) => (
          <React.Fragment>
            <div>
              <Row>
                <Col md={8}>
                  <Form className="d-flex">
                    <Col md={1}>ค้นหา : </Col>
                    <Col md={2}>
                      <Form.Select
                        size="sm"
                        name="periodSearch"
                        value={search.periodSearch}
                        // onChange={handleSearchDopaChange}
                        onChange={(e) => setField(e.target, e.target.value)}
                      >
                        <option value="">ปีที่ส่ง</option>
                        {optionPeriod.map((o, key) => (
                          <option key={key} value={o.season}>
                            {o.season}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={3}>
                      <Form.Select
                        size="sm"
                        name="factorySearch"
                        value={search.factorySearch}
                        // onChange={handleSearchStatusChange}
                        onChange={(e) => setField(e.target, e.target.value)}
                      >
                        <option value="">-- โรงงาน --</option>
                        {factoryFilter.map((o, key) => (
                          <option key={key} value={o.factoryCode}>
                            {o.factoryFullName}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={4}>
                      <FormControl
                        size="sm"
                        name="textSearch"
                        value={search.textSearch}
                        placeholder="เลขบัตรประชาชน"
                        // onChange={handleSearchChange}
                        onChange={(e) => setField(e.target, e.target.value)}
                      />
                    </Col>
                    <Col md={2}>
                      <Button
                        className="btn btn-info"
                        onClick={handleSearch}
                        style={{
                          margin: "0 0 0 0.5rem",
                          padding: ".375rem .75rem",
                          fontSize: ".75rem",
                        }}
                      >
                        <i className="bi bi-search"></i>
                      </Button>
                    </Col>
                  </Form>
                </Col>
                {/* <Col md={1}>{showCSVButton(prop)}</Col> */}
                <Col md={4} style={{ textAlign: "right" }}>
                  {/* {showCSVButton(prop)} */}
                  <button
                    className="btn btn-info"
                    onClick={onClickManage}
                    style={{
                      padding: ".375rem .75rem",
                      fontSize: "1rem",
                    }}
                  >
                    จัดการข้อมูล
                  </button>
                  <ExportCSVButton {...prop.csvProps}>
                    <i className="bi bi-download"></i>
                  </ExportCSVButton>
                </Col>
              </Row>
            </div>
            <hr />
            <BootstrapTable
              pagination={pagination}
              keyField="id"
              data={data}
              columns={columns}
              loading={true}
              filter={filterFactory()}
              // headerClasses="header-class"
              {...prop.baseProps}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default ContractListForOcsb;
